// removed by extract-text-webpack-plugin
module.exports = {"valueCol":"index__valueCol___2VAzC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/RadioField/index.less
// module id = 1212
// module chunks = 3